module.exports = __webpack_public_path__ + "img/zixun (1).61afeddc.png";